import styled from 'styled-components';

import { GridContainer } from '@xing-com/grid';
import { SingleSizeIllustrationHeroSearchFrog } from '@xing-com/illustrations';
import { mediaSmallOrTiny } from '@xing-com/layout-tokens';
import { space3XL, space4XL, spaceL } from '@xing-com/tokens';

const StyledGridContainer = styled(GridContainer)`
  align-items: center;
  margin-top: ${space4XL};

  @media ${mediaSmallOrTiny} {
    margin-top: ${space3XL};
  }
`;

const StyledSingleSizeIllustrationHeroSearchFrog = styled(
  SingleSizeIllustrationHeroSearchFrog
)`
  @media ${mediaSmallOrTiny} {
    margin-top: ${spaceL};
  }
`;

export const Styled = {
  GridContainer: StyledGridContainer,
  SingleSizeIllustrationHeroSearchFrog:
    StyledSingleSizeIllustrationHeroSearchFrog,
};
